
import React from "react";
import { useTheme } from "@/lib/theme/ThemeContext";
import { 
  AlertDialog, 
  AlertDialogAction, 
  AlertDialogCancel, 
  AlertDialogContent, 
  AlertDialogDescription, 
  AlertDialogFooter, 
  AlertDialogHeader, 
  AlertDialogTitle 
} from "@/components/ui/alert-dialog";
import { Database } from "@/types/supabase";

type Child = Database["public"]["Tables"]["children"]["Row"];

interface DeleteChildDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedChild: Child | null;
  onConfirm: () => void;
}

export function DeleteChildDialog({ open, onOpenChange, selectedChild, onConfirm }: DeleteChildDialogProps) {
  const isLightTheme = false;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className={isLightTheme ? "bg-white border-slate-200" : "bg-[#1A1F2C] border-[#333333]/80"}>
        <AlertDialogHeader>
          <AlertDialogTitle className={isLightTheme ? "text-slate-800" : "text-[#D6BCFA]"}>Are you sure?</AlertDialogTitle>
          <AlertDialogDescription className={isLightTheme ? "text-slate-600" : "text-[#C8C8C9]"}>
            This will permanently delete {selectedChild?.name}'s profile and all associated data including 
            sleep sessions, nap sessions, and feeding records. This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className={isLightTheme ? "bg-white border-slate-300 text-slate-800 hover:bg-slate-100" : "bg-[#222222] border-[#333333] text-[#C8C8C9] hover:bg-[#333333] hover:text-[#D6BCFA]"}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
